import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const Error404 = () => {
  const navigate = useNavigate();
  useEffect(() => {
    // Navigate to the home page when a user hit a route that doesn't exist
    navigate("/", { replace: true });
  }, [navigate]);
  return <div>404</div>;
};
